import axios from "axios";
import { apiUrl } from "../commons/inFormTypes";
import { config } from "react-spring";

const axiosInstance = axios.create({
  baseURL: apiUrl
  // baseURL به طور پیش‌فرض نمی‌ذاریم تا بتوانیم از URL کامل در هر درخواست استفاده کنیم
});

axiosInstance.interceptors.request.use(
  (config) => {   
    // بررسی اینکه اگر درخواست مربوط به login, checkcode, register نباشد، فیلدهای مشترک رو به داده‌ها اضافه کنه
    if (
      config.url !== "Login" &&
      config.url !== "CheckCode" &&
      config.url !== "Register"
    ) {
      const UserID = localStorage.getItem("UserId"); // فرض کنید Uid کاربر در localStorage ذخیره شده
      const TokenId = localStorage.getItem("tokenId");
      const Mobile = localStorage.getItem("user_mobile"); // فرض کنید موبایل کاربر در localStorage ذخیره شده

      if (TokenId && Mobile && UserID) {
        // اضافه کردن فیلدها به داده‌های درخواست (body)
        config.data = {
          ...config.data,
          Uid: UserID,
          mobile: Mobile,
          token: TokenId,
        };
      }
      // اضافه کردن baseURL برای درخواست‌هایی که این URL مستقل نیستند
      // config.baseURL = apiUrl;
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error.message);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    // در اینجا می‌توانید داده‌های پاسخ رو پردازش کنید
    // مثلاً اگر نیاز دارید که به طور پیش‌فرض داده‌ها رو از داخل response.data بگیرید
    return response; // پاسخ رو بدون تغییر برمی‌گردونیم
  },
  (error) => {
    // در اینجا خطاها رو مدیریت می‌کنید
    const status = error.response?.status;

    if (status === 401) {
      // خطای 401 (Unauthorized) - کاربر نیاز به لاگین مجدد دارد
      console.error("Unauthorized! Please log in again.");
      // می‌توانید کاربر رو به صفحه لاگین هدایت کنید
    } else if (status === 404) {
      // خطای 404 (Not Found) - منبع یافت نشد
      console.error("Resource not found:", error.response.data.message);
    } else if (status >= 500) {
      // خطای سرور (خطای 500 به بالا)
      console.error("Server error. Please try again later.");
    }

    // در نهایت، خطا رو برمی‌گردونیم تا در کامپوننت‌ها بتونید مدیریت کنید
    return Promise.reject(error);
  }
);

export default axiosInstance;
